import { render } from "./AddFriendPage.vue?vue&type=template&id=4e6d4dd4&scoped=true"
import script from "./AddFriendPage.vue?vue&type=script&lang=js"
export * from "./AddFriendPage.vue?vue&type=script&lang=js"

import "./AddFriendPage.vue?vue&type=style&index=0&id=4e6d4dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6d4dd4"]])

export default __exports__